import $ from 'jquery';
import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';

$('.news-slider__slider').each((i, elem) => {
    const $root = $(elem.closest('.news-slider'));
    const next = $root.find('.news-slider__nav .swiper-arrow--next')[0];
    const prev = $root.find('.news-slider__nav .swiper-arrow--prev')[0];

    const swiper = new Swiper(elem, {
        modules: [Navigation],
        slidesPerView: "auto",
        spaceBetween: 60,
        //loop: true, // loop does not work with `slidesPerView: "auto"`
        navigation: {
            nextEl: next,
            prevEl: prev,
        },
    });


    const $filter = $root.find('.news-slider__filter');
    const $showAllButton = $filter.find('.news-slider__filter-item .button[href="#all"]');
    const $filterButtons = $filter.find('.news-slider__filter-item .button[href^="#page-"]');

    function insertSortedSlides(parent, sortedSlides) {
        const canMoveBefore = Node && Node.prototype && typeof Node.prototype.moveBefore === "function";

        for (let i = 0; i < sortedSlides.length; i++) {
            const slide = sortedSlides[i];
            if (canMoveBefore) {
                parent.moveBefore(slide, null);
            } else {
                parent.insertBefore(slide, null);
            }
        }
    }

    function updateState() {
        let $activeButtons = $filterButtons.filter('.button--primary');

        $showAllButton.toggleClass('button--black', $activeButtons.length === 0);
        $showAllButton.toggleClass('button--outline-black', $activeButtons.length !== 0);

        let classes = [];
        if ($activeButtons.length === 0) {
            $activeButtons = $filterButtons.filter(':not(.js-exclude-default)');
        }
        classes = $activeButtons.map((_, elem) => $(elem).attr('href').substring(1)).get();
        classes = classes.map(c => `.${c}`).join(', ');

        const $parent = $root.find('.swiper-wrapper');
        const sortAscItems = $activeButtons.toArray().map(e => e.dataset.sortAscIfAlone === 'true');
        const sortAsc = sortAscItems.every(e => e);
        const currentOrder = $parent.data('currentOrder') || 'DESC';

        const $slides = $parent.children('.news-slider__item');
        $slides.addClass('d-none').filter(classes).removeClass('d-none');
        $slides.filter('.show-always').removeClass('d-none');

        if (
            sortAsc && currentOrder !== 'ASC'
            || !sortAsc && currentOrder === 'ASC'
        ) {
            $parent.data('currentOrder', sortAsc ? 'ASC' : 'DESC');
            let sortedSlides = $slides.toArray().sort((a, b) => {
                if (a.dataset.sortValue === 'end') return 1;
                if (b.dataset.sortValue === 'end') return -1;

                if (a.classList.contains('is-top-news') && !b.classList.contains('is-top-news')) return -1;
                if (!a.classList.contains('is-top-news') && b.classList.contains('is-top-news')) return 1;

                let aVal = parseInt(a.dataset.sortValue);
                let bVal = parseInt(b.dataset.sortValue);
                return sortAsc ? aVal - bVal : bVal - aVal;
            });
            insertSortedSlides($parent[0], sortedSlides);
        }

        swiper.update();
    }

    $showAllButton.on('click', ev => {
        ev.preventDefault();
        $filterButtons.removeClass('button--primary');
        $filterButtons.addClass('button--outline-primary');
        updateState();
    });

    $filterButtons.on('click', ev => {
        ev.preventDefault();
        const elem = ev.currentTarget;

        if (!ev.ctrlKey) {
            const $others = $filterButtons.filter((_, other) => !elem.isSameNode(other));
            $others.removeClass('button--primary');
            $others.addClass('button--outline-primary');
        }

        const added = elem.classList.toggle('button--primary');
        elem.classList.toggle('button--outline-primary', !added);
        updateState();
    });
});
